import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import BillRecever from "./BillRecever";

const styles = StyleSheet.create({
  invoiceNoContainer: {
    flexDirection: "row",
    marginTop: 20,
    justifyContent: "space-between",
    alignItems: "center",
  },
  invoiceDate: {
    fontSize: 12,
    fontStyle: "bold",
  },
  BillRecever: {
    width: "60%",
  },
  billNo: {
    width: "40%",
    paddingLeft: 25,
    alignSelf: "flex-end",
  },
});

const InvoiceNo = ({ invoice, buyer }) => (
  <Fragment>
    <View style={styles.invoiceNoContainer}>
      <BillRecever style={styles.BillRecever} buyer={buyer} />
      <View style={styles.billNo}>
        <View style={{ flexDirection: "row", marginBottom: 3 }}>
          <Text style={styles.label}>Invoice No:</Text>
          <Text style={styles.invoiceDate}>{invoice.invoice_no}</Text>
        </View>
        <View style={{ flexDirection: "row" }}>
          <Text>Date: </Text>
          <Text style={styles.invoiceDate}>{invoice.trans_date}</Text>
        </View>
      </View>
    </View>
  </Fragment>
);

export default InvoiceNo;
